export const isImgUrl = (ImageUrl: string) => /\.(jpg|jpeg|png|webp|avif|gif)$/.test(ImageUrl);